<template>
  <div id="weighting-filter-container">
    <div class="weighting-title-container row-block">
      <div class="title">指標加權</div>
      <div :style="{ flex: 1 }"></div>
    </div>
    <div class="weighting-filter-group" v-for="(filter, index) in filters" :key="index">
      <template v-if="conditions[filter.value]">
        <div class="title-block row-block">
          <div class="title">{{ filter.title }}</div>
          <div :style="{ flex: 1 }"></div>
          <switchButton type="primary" size="small" :disabled="disabled" :checked="conditions[filter.value].active" @input="value => conditions[filter.value].active = value"></switchButton>
          <div :style="{ width: '30px' }"></div>
        </div>
        <div class="options" :class="['slider']">
          <div class="input-group">
            <div class="slider">
              <vueSlider
                v-model="conditions[filter.value].value"
                v-bind="filter.options"
                :disabled="!conditions[filter.value].active"
                :tooltip="'none'"
                :dotSize="9"
                :dotStyle="{
                  background: '#555555'
                }"
                :processStyle="{
                  background: conditions[filter.value].active ? '#B4E04F' : '#444444'
                }"
              ></vueSlider>
            </div>
            <div class="value">
              <span>{{ conditions[filter.value].active ? conditions[filter.value].value : 0 }}</span>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import vueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'
import switchButton from '../tool/switchButton'

export default {
  components: {
    vueSlider,
    switchButton
  },
  props: {
    init: {
      type: Object,
      default: () => ({})
    },
    filters: {
      type: Array,
      required: true
    },
    disabled: {
      type: Boolean,
      default: () => false
    }
  },
  data () {
    return {
      conditions: {},
      output: {}
    }
  },
  watch: {
    'init' () {
      this.initialConditions()
    },
    'filters' () {
      this.initialConditions()
    },
    'conditions': {
      handler: async function () {
        this.output = await this.afterTreatment(this.conditions)
        this.$emit('change', this.output)
      },
      deep: true
    }
  },
  created () {
    this.initialConditions()
  },
  methods: {
    async initialConditions () {
      let input = await this.preTreatment(this.init)
      let initials = {
        slider: () => ({ active: true, value: 0 })
      }
      this.conditions = this.filters.reduce((s, c) => ({ ...s, ...{ [c.value]: input[c.value] || initials['slider']() } }), {})
    },
    async preTreatment (init) {
      let input = {}
      for (let filter of this.filters) {
        input[filter.value] = await (filter.inputFormat || (async x => x))(init[filter.value])
      }
      return input
    },
    async afterTreatment (conditions) {
      let output = {}
      for (let filter of this.filters) {
        output[filter.value] = await (filter.outputFormat || (async x => ({ ...x, title: filter.title })))(conditions[filter.value])
      }
      return output
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass">
#weighting-filter-container
  .weighting-title-container
    margin-bottom: 10px
    padding: 0 5px
    .title
      color: #9BC737
      font-size: 16px
      font-weight: bold
  .weighting-filter-group
    &:not(:last-child)
      margin-bottom: 15px
    .title
      padding: 0 5px
    .options
      & > div
        padding: 5px
      &.slider
        & > div
          display: flex
          .value
            width: 27px
            text-align: right
          .slider
            display: inline
            flex: 1
</style>



// WEBPACK FOOTER //
// src/components/tool/weightingFilter.vue